import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Close from './close.vue'

export const closeProps = buildProps({
  hover: {
    type: String,
  },
})

export type CloseProps = ExtractPropTypes<typeof closeProps>
export type CloseInstance = InstanceType<typeof Close>
